import React from "react";
import styled from "styled-components";
import rightArrow from "assets/icons/right-arrow.webp";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";

const PaymentMethod = () => {
  const navigate = useNavigate();
  return (
    <>
      <Title>결제 수단</Title>
      <Wrap
        onClick={() => {
          navigate(routes.depositAccountManage);
        }}
      >
        <div>
          <WrapTitle>입금계좌 관리</WrapTitle>
        </div>
        <Flex>
          <WrapContent>
            <Content>등록하기 또는 수정하기</Content>
          </WrapContent>
          <Img src={rightArrow} alt="오른쪽화살표" />
        </Flex>
      </Wrap>
      <Bar />
    </>
  );
};

export default PaymentMethod;

const Title = styled.div`
  padding: 11px 0px 3px 0px;
  height: 24px;
  font-weight: normal;
  font-size: 13px;
  color: #666666;
`;

const Wrap = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
const Flex = styled.div`
  display: flex;
`;
const Img = styled.img`
  width: 44px;
  height: 44px;
  align-self: center;
`;
const WrapTitle = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: #222222;
`;
const WrapContent = styled.span`
  height: 56px;
  margin-right: -7px;
`;
const Content = styled.span`
  line-height: 56px;
  vertical-align: middle;
  font-weight: normal;
  font-size: 14px;
  color: #444444;
`;
const Bar = styled.div`
  height: 24px;
  background-color: #ffffff;
`;
